import React from 'react'
import GenericToggle from '../GenericToggle/GenericToggle'
import Link from 'next/link'
import { ButtonGroup, Dropdown } from 'react-bootstrap'
import classNames from 'classnames'
import { logoutFromB2BAccount } from '../../utils/auth'

import styles from './AccountDropdown.module.scss'

const AccountDropdown = ({
  userData,
  accountUrl,
  signOutUrl,
  publicAppDashboardUrl,
  kp4Url,
  knoxAdminPortal,
  onSignOut
}) => {
  const ProfileImage = ({ userData, large }) => {
    const initials = userData.firstName[0] + userData.lastName[0]
    return (
      <div className={classNames(styles.avatar, { [styles.large]: large })}>
        <span className={classNames(styles.initials, { [styles.large]: large })}>{initials}</span>
      </div>
    )
  }

  const handleSignOut = (e) => {
    e.preventDefault()

    // Clear storage
    if (typeof window !== 'undefined') {
      window.sessionStorage.clear()
    }

    // Check if this is a B2B user and use the appropriate logout method
    if (userData?.idpType === 'B2B_SAMSUNG_ACCOUNT') {
      logoutFromB2BAccount()
    } else {
      // Use regular logout for B2C users
      window.location.href = signOutUrl
    }
  }

  if (!userData) {
    return <></>
  }
  return (
    <Dropdown
      as={ButtonGroup}
      className={classNames(styles.dashboardNavWrapper, 'avatar')}
      alignRight
    >
      <Dropdown.Toggle
        as={GenericToggle}
        id="dropdown-custom-components"
        className={styles.dropdownButton}
      >
        <ProfileImage userData={userData} />
      </Dropdown.Toggle>
      <Dropdown.Menu className={classNames(styles.accountProfileDropDown)}>
        <div className="pl-2 pr-2 pt-2">
          <p>
            <b>
              {userData.firstName} {userData.lastName}
            </b>
          </p>
          <p>{userData.email}</p>
          <p>CustomerID: {userData.amsCustomerId}</p>
        </div>
        <hr />
        {publicAppDashboardUrl && (
          <Dropdown.Item eventKey="1" as={Link} href={publicAppDashboardUrl}>
            My Knox
          </Dropdown.Item>
        )}
        {kp4Url && (
          <Dropdown.Item eventKey="1" as={Link} href={kp4Url}>
            <a className="dropdown-item">
              <span>Knox Home Page</span>
              <img
                src="https://kp4-cdn.samsungknox.com/resource/icon-arrow-up-right_SjhM.svg"
                alt="Arrow Up Right logo"
              />
            </a>
          </Dropdown.Item>
        )}
        {knoxAdminPortal && (
          <Dropdown.Item eventKey="1" as={Link} href={knoxAdminPortal}>
            <a className="dropdown-item">
              <span>Knox Admin Portal</span>
              <img
                src="https://kp4-cdn.samsungknox.com/resource/icon-arrow-up-right_SjhM.svg"
                alt="Arrow Up Right logo"
              />
            </a>
          </Dropdown.Item>
        )}
        {accountUrl && (
          <Dropdown.Item eventKey="2" as={Link} href={accountUrl}>
            <a className="dropdown-item">
              <span>Account Information</span>
              <img
                src="https://kp4-cdn.samsungknox.com/resource/icon-arrow-up-right_SjhM.svg"
                alt="Arrow Up Right logo"
              />
            </a>
          </Dropdown.Item>
        )}
        {signOutUrl && (
          <Dropdown.Item eventKey="3" onClick={onSignOut || handleSignOut}>
            Sign out
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default AccountDropdown
